export default __webpack_public_path__ + "static/media/close.3dc45c28.svg";